export const environment = {
  production: true,
  buildId: '3927234110723931',
  configFile: 'config.json',
};
